import React from "react";
import "./closebutton.scss";
export const CloseButton = _ref => {
  let {
    onClick,
    className,
    iconColor = "brand-primary",
    ariaLabel
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    className: "close-button ".concat(className || ""),
    onClick: onClick,
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-xmark text-".concat(iconColor)
  }));
};